module.exports = __webpack_public_path__ + "static/media/plus-icon.d2f74ad7.svg";